import styled from '@emotion/styled';

export const StyledHeadWrapper = styled.div`
  & > strong {
    font-weight: 700;
    font-size: 24px;
    line-height: 34.75px;
  }
`;

export const StyledMenuWrapper = styled.div`
  margin-top: 11px;
  margin-bottom: 61px;

  display: flex;

  & div {
    padding: 9px 18px;
    border-bottom: 2px solid #999999;

    & a {
      color: #555;
      text-decoration: none;
      font-size: 18px;
    }

    &.selected {
      border-bottom: 2px solid #00bf00;
      & a {
        color: #00bf00;
      }
    }
  }
`;
